import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrientationArrowBlack = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 20,
	viewBox: "0 0 20 20",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m12.8282 9.10149-2.82838-2.82842-2.82843 2.82842",
			stroke: "#000",
			strokeLinecap: "square",
			strokeMiterlimit: 10,
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m10 2c4.4111 0 8 3.58878 8 8 0 4.4112-3.5889 8-8 8-4.41113 0-8-3.5888-8-8 0-4.41122 3.58887-8 8-8zm0-2c-5.52295 0-10 4.47714-10 10 0 5.5229 4.47705 10 10 10 5.523 0 10-4.4771 10-10 0-5.52286-4.477-10-10-10z",
			fill: "#000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m10 6.27307v8.00003",
			stroke: "#000",
			strokeMiterlimit: 10,
			strokeWidth: 1.5
		})
	]
});
export default SvgOrientationArrowBlack;
